import { JSX, Match, Switch } from "solid-js";
import { VoucherHighlight } from "~/server/types/brand";
import {
  multipleTimes,
  offline,
  online,
  onlineOffline,
  singleTime,
  subscription,
  validForOneYear,
} from "~/assets/brand_highlight_svg_icons";

export type VoucherPropertiesProps = {
  voucherHighlights: VoucherHighlight[];
};

/**
 * Display voucher properties: Redeem type, Expiry, Usage
 */
export function VoucherProperties(props: VoucherPropertiesProps) {
  const highlights = props.voucherHighlights;

  return (
    <div class="flex gap-[9px]">
      {/* Redeem type - based on ONLINE/OFFLINE/ONLINE_OFFLINE/SUBSCRIPTION */}
      <Switch>
        <Match when={highlights.includes("ONLINE_OFFLINE")}>
          <PropertyPill
            iconUrlBuilder={onlineOffline}
            label="Redeem"
            value="Online & In-store"
          />
        </Match>
        <Match when={highlights.includes("ONLINE")}>
          <PropertyPill iconUrlBuilder={online} label="Redeem" value="Online" />
        </Match>
        <Match when={highlights.includes("OFFLINE")}>
          <PropertyPill
            iconUrlBuilder={offline}
            label="Redeem"
            value="In-store"
          />
        </Match>
        <Match when={highlights.includes("SUBSCRIPTION")}>
          <PropertyPill
            iconUrlBuilder={subscription}
            label="Redeem"
            value="Subscription"
          />
        </Match>
      </Switch>

      {/* Expiry - based on VALID_FOR_* highlights */}
      <Switch>
        <Match when={highlights.includes("VALID_FOR_ONE_YEAR")}>
          <PropertyPill
            iconUrlBuilder={validForOneYear}
            label="Expiry"
            value="1 year"
          />
        </Match>
        <Match when={highlights.includes("VALID_FOR_NINE_MONTHS")}>
          <PropertyPill
            iconUrlBuilder={validForOneYear}
            label="Expiry"
            value="9 months"
          />
        </Match>
        <Match when={highlights.includes("VALID_FOR_SIX_MONTHS")}>
          <PropertyPill
            iconUrlBuilder={validForOneYear}
            label="Expiry"
            value="6 months"
          />
        </Match>
        <Match when={highlights.includes("VALID_FOR_THREE_MONTHS")}>
          <PropertyPill
            iconUrlBuilder={validForOneYear}
            label="Expiry"
            value="3 months"
          />
        </Match>
      </Switch>

      {/* Usage - based on MULTIPLE_TIMES/SINGLE_TIME */}
      <Switch>
        <Match when={highlights.includes("MULTIPLE_TIMES")}>
          <PropertyPill
            iconUrlBuilder={multipleTimes}
            label="Usage"
            value="Multiple times"
          />
        </Match>
        <Match when={highlights.includes("SINGLE_TIME")}>
          <PropertyPill
            iconUrlBuilder={singleTime}
            label="Usage"
            value="One time"
          />
        </Match>
      </Switch>
    </div>
  );
}

type PropertyPillProps = {
  iconUrlBuilder: () => JSX.Element;
  label: string;
  value: string;
};

function PropertyPill(props: PropertyPillProps) {
  return (
    <div class="flex flex-1 flex-col items-center justify-center gap-3 rounded-[12px] bg-background-normal-secondary px-2 py-3">
      <div class="h-[30px] w-[30px] stroke-stroke-solid">
        {props.iconUrlBuilder()}
      </div>
      <div class="flex flex-col items-center gap-1 text-center">
        <div class="text-caption-medium uppercase tracking-[0.4px] text-text-normal-secondary">
          {props.label}
        </div>
        <div class="text-label-medium text-text-normal-primary">
          {props.value}
        </div>
      </div>
    </div>
  );
}
